import { getRelativePath } from 'base/shared/Utils';

export const getSuccessPurchaseUrl = () => getRelativePath(`/purchase/success`);
